module.exports = __webpack_public_path__ + "static/media/5. Impresión, Mixta sobre madera, 76 x 107 cm, 2018 copy.809dcb95.png";